import {
    HTTP_INTERCEPTORS,
    HttpClient,
    provideHttpClient,
    withInterceptors,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { APP_INITIALIZER, enableProdMode, importProvidersFrom, Injector } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
    InMemoryScrollingOptions,
    provideRouter,
    withComponentInputBinding,
    withInMemoryScrolling,
    withRouterConfig,
} from '@angular/router';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { globalHttpInterceptorFn } from '@core/interceptors';
import { appInitializerFactory } from '@core/services/app.factories';
import { SeqPageTitlesService } from '@core/services/page-titles.service';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { environment } from './environments/environment';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}

if (environment.production) {
    enableProdMode();
}

const auth0_audience = 'TYX_Sequencing_API';
const auth0_cacheLocation = 'localstorage';

const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'top',
};

bootstrapApplication(AppComponent, {
    providers: [
        MessageService,
        ConfirmationService,
        SeqPageTitlesService,
        importProvidersFrom(
            BrowserModule,
            AuthModule.forRoot({
                domain: environment.auth0.domain,
                clientId: environment.auth0.clientId,
                cacheLocation: auth0_cacheLocation,
                authorizationParams: {
                    redirect_uri: environment.auth0.redirectUri + '',
                    audience: auth0_audience,
                },
                httpInterceptor: {
                    allowedList: [
                        {
                            uri: `${environment.apiUrl}/*`,
                            tokenOptions: {
                                authorizationParams: {
                                    audience: auth0_audience,
                                },
                            },
                        },
                    ],
                },
            }),
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient],
                },
            }),
            ToastModule
        ),
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [TranslateService, SeqPageTitlesService, Injector],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptor,
            multi: true,
        },
        provideRouter(
            appRoutes,
            withInMemoryScrolling(scrollConfig),
            withComponentInputBinding(),
            withRouterConfig({ paramsInheritanceStrategy: 'always' })
        ),
        provideAnimations(),
        provideHttpClient(withInterceptors([globalHttpInterceptorFn]), withInterceptorsFromDi()),
    ],
}).catch(err => console.error(err));
